<template>
  <div class="single-stat">
     <h4 class="m-b-20">

       <img src="../../../assets/images/svg_icons/artist.svg" width="30" alt="">
       {{ stat.designerName }}
       
       </h4>
     <p>Total drafts sent: {{ stat.totalDrafts }}</p>

     <single-horizontal-bar :status-count="stat.approved.length" title="Approved" :total-drafts="stat.totalDrafts" color-code="#4cd137"/>
     <single-horizontal-bar :status-count="stat.unapproved.length" title="Unapproved" :total-drafts="stat.totalDrafts" color-code="#c23616"/>
     <single-horizontal-bar :status-count="stat.mixedResponse.length" title="Mixed Response" :total-drafts="stat.totalDrafts" color-code="#00a8ff" note="Approved + Unapproved"/>
     <single-horizontal-bar :status-count="stat.untouched.length" title="Untouched" :total-drafts="stat.totalDrafts" color-code="#7f8fa6"/>
  </div>
</template>

<script>
  const SingleHorizontalBar  = () => import(/* webpackChunkName: "single-horizontal-bar" */ './single-horizontal-bar')
  export default {
    components: {SingleHorizontalBar},
    props: {
      stat: {
        type: Object,
        default: () => ({})
      }
    },
  }
</script>

<style lang="scss" scoped>
  .single-stat{
     padding: 20px;
     border: 1px solid rgb(216, 216, 216);
     margin-bottom: 20px;
     border-radius: 5px;
  }
</style>